export default "__VITE_ASSET__C9vbG82a__"